module.exports = __webpack_public_path__ + "media/images/cplook/apple-touch-icon-152x152-4e7e326e441d8004cb074e6f09a8d486.png";